 <template>
    <div class="services-area ptb-100">
        <div class="container">
            <div class="team-text">
                <h2>{{ $t('services_main_title') }}</h2>
                <p  style="padding-top:10px;">
                    {{ $t('services_main_p') }}
                </p>
            </div>

            <div class="row">
                <router-link to="/implants" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/implants">
                                <img src="../../assets/images/services/implants/implant-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/all-on-x-details">
                                    <i class="flaticon-dental-implant"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                <router-link to="/implants">
                                    {{ $t('nav_implants') }}
                                    
                                </router-link>
                            </h3>
                            <p>{{ $t('services_main_implants_p') }}</p>
                        </div>
                    </div>
                </router-link>

                <router-link to="/all-on-x-details" class="col-lg-4 col-md-6" style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/all-on-x-details">
                                <img src="../../assets/images/services/all6/all6-services.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/all-on-x-details">
                                    <i class="flaticon-dental-implant"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('nav_allx') }}
                            </h3>
                            <p>{{ $t('services_main_allx_p') }}</p>
                        </div>
                    </div>
                </router-link>
                
                
                <router-link to="/full-mouth-rehabilitation" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/full-mouth-rehabilitation">
                                <img src="../../assets/images/services/full-mouth-rehab/full-mouth-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/full-mouth-rehabilitation">
                                    <i class="flaticon-dental-implant"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('nav_rehab') }}
                            </h3>
                            <p>{{ $t('services_main_mouthRehab_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/veneers" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/veneers">
                                <img src="../../assets/images/services/zircCrowns/zirconia-crowns-allservices.webp"  alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/veneers">
                                    <i class="flaticon-dental-care"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('zircven_page_title') }}
                                    
                            </h3>
                            <p>{{ $t('services_main_zcrowns_veneers_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/hollywood-smile" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/hollywood-smile">
                                <img src="../../assets/images/services/hollywoodSmile/hollywood-smile-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/hollywood-smile">
                                    <i class="flaticon-dental-care"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('nav_hsmile') }}
                            </h3>
                            <p>{{ $t('services_main_hsmile_p') }}</p>
                        </div>
                    </div>
                </router-link>

                
                <router-link to="/zirconia-bridges" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/zirconia-bridges">
                                <img src="../../assets/images/services/bridges/zirc-bridge-allservices.webp"  alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/zirconia-bridges">
                                    <i class="flaticon-dental-care"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('nav_zbridges') }}
                                    
                            </h3>
                            <p>{{ $t('services_main_zbridges_p') }}</p>
                        </div>
                    </div>
                </router-link>
                
                
                
                <router-link to="/whitening" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/whitening">
                                <img src="../../assets/images/services/whitening/whitening-service.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/whitening">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('whitening_service_page_title') }}
                                    
                            </h3>
                            <p>{{ $t('services_main_whitening_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/denture" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/denture">
                                <img src="../../assets/images/services/denture/denture-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/denture">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('denture_all_service_page_title') }}
                                    
                            </h3>
                            <p>{{ $t('services_main_denture_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/inlays-onlays" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/inlays-onlays">
                                <img src="../../assets/images/services/inonlays/inonlay-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/inlays-onlays">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('prosthetics_lays_all_service_page_title') }}
                                    
                            </h3>
                            <p>{{ $t('services_main_lays_p') }}</p>
                        </div>
                    </div>
                </router-link>

                <router-link to="/periodontology" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/periodontology">
                                <img src="../../assets/images/services/periodontology/periodontology_services.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/periodontology">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('periodontology_services_title') }}
                                    
                            </h3>
                            <p>{{ $t('periodontology_services_p') }}</p>
                        </div>
                    </div>
                </router-link> 
                <router-link to="/orofacial-pain" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/orofacial-pain">
                                <img src="../../assets/images/services/orofacial-pain/orofacial_allservices_page.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/orofacial-pain">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('orofacial_services_title') }}
                                    
                            </h3>
                            <p>{{ $t('orofacial_services_p') }}</p>
                        </div>
                    </div>
                </router-link> 
                <router-link to="/face-improvement" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/face-improvement">
                                <img src="../../assets/images/services/facial-aesthetics/face-improvement/face-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/face-improvement">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('face_improvement_services_title') }}
                                    
                            </h3>
                            <p>{{ $t('face_improvement_services_p') }}</p>
                        </div>
                    </div>
                </router-link>

                <router-link to="/prp-therapy" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/prp-therapy">
                                <img src="../../assets/images/services/facial-aesthetics/prp-therapy/prp-service.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/prp-therapy">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('prp_service_title') }}
                                    
                            </h3>
                            <p>{{ $t('prp_service_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/botox-etc" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/botox-etc">
                                <img src="../../assets/images/services/facial-aesthetics/botox-etc/botox-allservices.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/botox-etc">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('botox_service_title') }}
                                    
                            </h3>
                            <p>{{ $t('botox_service_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/alternative-therapies" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/alternative-therapies">
                                <img src="../../assets/images/services/facial-aesthetics/alternative-ways/aisthitikos-velonismos-services.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/alternative-therapies">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('alternative_therapies_service_title') }}
                                    
                            </h3>
                            <p>{{ $t('alternative_therapies_service_p') }}</p>
                        </div>
                    </div>
                </router-link>
                <router-link to="/invisible-orthodontics" class="col-lg-4 col-md-6"  style="margin-top: 30px;">
                    <div class="single-services">
                        <div class="services-image">
                            <router-link to="/invisible-orthodontics">
                                <img src="../../assets/images/services/invisible-orthodontics/invisibleOrthodontics-services_page.webp" alt="image">
                            </router-link>

                            <div class="icon">
                                <router-link to="/invisible-orthodontics">
                                    <i class="flaticon-chair"></i>
                                </router-link>
                            </div>
                        </div>

                        <div class="services-content">
                            <h3>
                                    {{ $t('invisible_orthodontics_services_title') }}
                                    
                            </h3>
                            <p>{{ $t('invisible_orthodontics_services_p') }}</p>
                        </div>
                    </div>
                </router-link>
                
                
            </div>
        </div>
        <div class="container" style="padding-top: 50px;">
            <p>{{ $t('services_main_p_sedation') }}  <router-link to="/conscious-sedation"><u><b>{{ $t('services_main_p_here') }}</b></u></router-link>!</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DentalServices'
}
</script>
